/**
 * CREW PROBABILITY - Composants réutilisables pour la probabilité
 */

import { Frown, Meh, Smile } from 'lucide-react';
import { CREW_PROBABILITY, CREW_PROBABILITY_LABELS } from '@/types/crew';
import type { CrewProbability } from '@/types/crew';

/**
 * Composant Smiley selon la probabilité
 */
interface ProbabilityIconProps {
  probability: CrewProbability;
  className?: string;
}

export function ProbabilityIcon({ probability, className = 'h-4 w-4' }: ProbabilityIconProps) {
  if (probability === CREW_PROBABILITY.LOW) {
    return <Frown className={className} />;
  }
  if (probability === CREW_PROBABILITY.MEDIUM) {
    return <Meh className={className} />;
  }
  if (probability === CREW_PROBABILITY.HIGH) {
    return <Smile className={className} />;
  }
  return null;
}

/**
 * Affichage complet de la probabilité avec icône et label
 */
interface ProbabilityDisplayProps {
  probability: CrewProbability;
  showIcon?: boolean;
  showLabel?: boolean;
  className?: string;
}

export function ProbabilityDisplay({
  probability,
  showIcon = true,
  showLabel = true,
  className = '',
}: ProbabilityDisplayProps) {
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {showIcon && <ProbabilityIcon probability={probability} />}
      {showLabel && <span>{CREW_PROBABILITY_LABELS[probability]}</span>}
    </div>
  );
}
